module.exports = __webpack_public_path__ + "static/media/cosmetics defects.4e936a13.png";